import { defineAsyncComponent } from 'vue'
export default {
  about: defineAsyncComponent(() => import("/Users/mile/Projekti/tvornicazdravehrane.com/layouts/about.vue").then(m => m.default || m)),
  default: defineAsyncComponent(() => import("/Users/mile/Projekti/tvornicazdravehrane.com/layouts/default.vue").then(m => m.default || m)),
  blank: defineAsyncComponent(() => import("/Users/mile/Projekti/nuxt-base/layouts/blank.vue").then(m => m.default || m)),
  bot: defineAsyncComponent(() => import("/Users/mile/Projekti/nuxt-base/layouts/bot.vue").then(m => m.default || m))
}